import "./index.css";
import React, { useState } from "react";
import { AuthZTable, defaultPageSizeOptions } from "../../../../components/authZTable";
import { createConditionTree } from "../../../../components/condition/utils/createConditionTree";
import ListKeyConditions from "../../../../components/condition/view/keyConditions";
import { PreviewMembershipController } from "./controller";
import { defaultTablePageAndSize, tableIds } from "./model";
import { PreviewExsitingKeyConditions } from "../../../../components/condition/view/previewExsitingKeyConditions";
import { findListOfKeyConditions } from "../../../../components/condition/utils/findListOfKeyConditions";
import { UserTableColumnGenerator } from "../../../../components/InfoTab/UsersTable/userTableColumnGenerator";
import { SpecialConditions } from "../../../../components/condition/view/specialConditions";
import { KeyConditionAction } from "../model";
import KeyConditionDifference from "../../../../components/condition/view/keyConditionDifference";
import { findConditionById } from "../../../../components/condition/utils/findConditionById";
import { isNullOrUndefined } from "../../../../common/utils";
import { Collapse } from "antd";
import { QuestionCircleFilled, WarningFilled } from "@ant-design/icons";
import { CollapseComponent } from "src/components/Collapse";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import { ShieldUserFillIcon } from "src/components/shieldUserFill";
import { useIsIndividualInclusionNamingEnabled } from "../common/hooks/IsIndividualInclusionNamingEnabled";

export const PreviewMembership = ({ userGroupUniqueName }) => {
  const [addedPagination, setAddedPagination] = useState(defaultTablePageAndSize);
  const [stayingPagination, setStayingPagination] = useState(defaultTablePageAndSize);
  const [removedPagination, setRemovedPagination] = useState(defaultTablePageAndSize);
  const isIndividualInclusionNamingEnabled = useIsIndividualInclusionNamingEnabled();

  const Panel = Collapse.Panel;

  const {
    isSpecialConditionChecked,
    selectSpecialUser,
    modifiedKeyCondition,
    columns,
    addedValue,
    stayingValue,
    removedValue,
    isLoadingForAdded,
    isLoadingForStaying,
    isLoadingForRemoved,
    membershipConditionsTree,
    userGroupIndividualInclusions,
    action,
    editingConditionId,
    loading,
    rowClassNameFn
  } = PreviewMembershipController(
    userGroupUniqueName,
    addedPagination,
    stayingPagination,
    removedPagination,
  );

  const keyCondition = getKeyConditionBasedOnAction();
  const individualInclusionIds = userGroupIndividualInclusions?.map((userGroupIndividualInclusion) => {
    return userGroupIndividualInclusion.userId;
  });
  const userGroupUnEditedIndividualInclusions = userGroupIndividualInclusions?.filter((individualInclusion) => {
    return individualInclusion.userId !== selectSpecialUser?.key;
  });

  let titleForExistingKeyCondition = "";
  let keyConditions = [];
  if (membershipConditionsTree.isKeyCondition === true && membershipConditionsTree.key !== editingConditionId) {
    keyConditions.push(membershipConditionsTree);
  } else if (membershipConditionsTree.isSingleOperand() === false) {
    keyConditions = membershipConditionsTree.operands.filter(
      (keyCondition) =>
        keyCondition.isKeyCondition === true && keyCondition.key !== editingConditionId,
    );
  }
  titleForExistingKeyCondition = "Existing key conditions (" + keyConditions.length + ")";

  function getKeyConditionBasedOnAction() {
    if (action === KeyConditionAction.DELETE) {
      return findConditionById(membershipConditionsTree, editingConditionId);
    } else {
      return createConditionTree(modifiedKeyCondition, null);
    }
  }

  const onPageChange = (tableId, current) => {
    switch (tableId) {
      case tableIds.addedTable:
        setAddedPagination({ ...addedPagination, page: current });
        break;
      case tableIds.stayingTable:
        setStayingPagination({ ...stayingPagination, page: current });
        break;
      case tableIds.removedTable:
        setRemovedPagination({ ...removedPagination, page: current });
        break;
      default: {
      }
    }
  };

  function changePageSize(tableId, pageSize, _) {
    switch (tableId) {
      case tableIds.addedTable:
        setAddedPagination((prevState) => {
          addedPagination.size = pageSize;
          return { addedPagination };
        });
        break;
      case tableIds.stayingTable:
        setStayingPagination((prevState) => {
          stayingPagination.size = pageSize;
          return { stayingPagination };
        });
        break;
      case tableIds.removedTable:
        setRemovedPagination((prevState) => {
          removedPagination.size = pageSize;
          return { removedPagination };
        });
        break;
      default: {
      }
    }
  }

  const totalElementsForAdded = addedValue.totalElements;
  const addedData = addedValue.data;

  const totalElementsForStaying = stayingValue.totalElements;
  const stayingData = stayingValue.data;

  const totalElementsForRemoved = removedValue.totalElements;
  const removedData = removedValue.data;

  const modifiedColumns = UserTableColumnGenerator(columns, individualInclusionIds, false, false);

  let existingKeyCondition = [];
  findListOfKeyConditions(membershipConditionsTree, existingKeyCondition);
  let existingKeyConditionThatIsEdited;
  if (!isNullOrUndefined(editingConditionId)) {
    existingKeyConditionThatIsEdited = findConditionById(
      membershipConditionsTree,
      editingConditionId,
    );
  }

  function getDeleteClassName() {
    if (action === KeyConditionAction.DELETE) {
      return "delete-list-key-condition";
    } else {
      return "";
    }
  }

  function getDeleteMessage() {
    if (action === KeyConditionAction.DELETE) {
      return (
        <span className="preview-delete-key-condition-message">
          You are deleting this condition
        </span>
      );
    } else {
      return null;
    }
  }

  function renderExistingKeyConditions() {
    return (
      <Panel header={`${getPanelTitleBasedOnAction()} Key Conditions`} key="1">
        {!isSpecialConditionChecked ? (
          <div className={`preview-key-condition-container ${getDeleteClassName()}`}>
            {isNullOrUndefined(action) ? null : (
              <>
                {action !== KeyConditionAction.EDIT ? (
                  <ListKeyConditions
                    listOfKeyConditions={[keyCondition]}
                    haveMembershipConditionsEditAccess={false}
                  />
                ) : (
                  <KeyConditionDifference
                    mainKeyCondition={existingKeyConditionThatIsEdited}
                    editedKeyCondition={keyCondition}
                  />
                )}
              </>
            )}
          </div>
          ) : (
            null
        )}
      </Panel>
    )
  }

  function renderOtherKeyConditions() {
    return (
      <Panel header={titleForExistingKeyCondition} key="2">
        <div>
          {keyConditions.length === 0 ? (
            <div style={{paddingTop:"8px"}}>There are no existing key conditions</div>
          ) : (
            <div className={"preview-table-container"}>
              <PreviewExsitingKeyConditions
                conditionTree={membershipConditionsTree}
                keyConditionToBeOmitted={editingConditionId}
                keyConditions={keyConditions}
              />
            </div>
          )}
        </div>
      </Panel>
    );
  }

  function renderExistingIndividualInclusions() {
    return (
      <Panel
        header={`Existing ${
          isIndividualInclusionNamingEnabled ? "individual inclusions" : "special members"
        } (${
          userGroupUnEditedIndividualInclusions?.length
            ? userGroupUnEditedIndividualInclusions?.length
            : 0
        })`}
        key="2"
      >
        <div>
          {userGroupUnEditedIndividualInclusions.length === 0 ? (
            <div style={{ paddingTop: "8px" }}>
              There are no existing{" "}
              {isIndividualInclusionNamingEnabled ? (
                <>individual inclusions</>
              ) : (
                <>special members</>
              )}
            </div>
          ) : (
            <div className={"preview-table-container"}>
              <SpecialConditions
                individualInclusionMembers={userGroupUnEditedIndividualInclusions}
              />
            </div>
          )}
        </div>
      </Panel>
    );
  }

  function returnNewMembersMatchingConditions() {
    return (
      <CollapsePanel
        header={
          <>
            <div>
              <QuestionCircleFilled className={"added-icon"} />
            </div>
            <div>
              New People who match the selected key conditions (
              {totalElementsForAdded ? totalElementsForAdded : 0})
            </div>
          </>
        }
        key="1"
      >
        <div className={"preview-table-container"}>
          {totalElementsForAdded > 0 ? (
            <div>
              <AuthZTable
                id={tableIds.addedTable}
                rowKey={"key"}
                columns={modifiedColumns}
                dataSource={addedData}
                loading={isLoadingForAdded}
                rowClassName={rowClassNameFn}
                pagination={{
                  showSizeChanger: true,
                  showQuickJumper: true,
                  pageSize: addedPagination.size,
                  pageSizeOptions: defaultPageSizeOptions,
                  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                  current: addedPagination.page,
                  total: totalElementsForAdded,
                  onShowSizeChange: (current, pageSize) =>
                    changePageSize(tableIds.addedTable, pageSize, current),
                  onChange: (current) => onPageChange(tableIds.addedTable, current),
                }}
                scroll={{ x: "max-content", y: "calc(64vh)" }}
              />
            </div>
          ) : <div>There are no users that will be added newly</div>}
        </div>
      </CollapsePanel>
    );
  }

  function returnPeopleLosingMembershipTable() {
    return (
      <CollapsePanel
        header={
          <>
            <div>
              <WarningFilled className={"removed-icon"} />
            </div>
            <div>People losing team membership ({totalElementsForRemoved ? totalElementsForRemoved : 0})</div>
          </>
        }
        key="2"
      >
        <div className={"preview-table-container"}>
          {totalElementsForRemoved > 0 ? (
            <AuthZTable
              id={tableIds.removedTable}
              rowKey={"key"}
              columns={modifiedColumns}
              dataSource={removedData}
              loading={isLoadingForRemoved}
              rowClassName={rowClassNameFn}
              pagination={{
                showSizeChanger: true,
                showQuickJumper: true,
                pageSize: removedPagination.size,
                pageSizeOptions: defaultPageSizeOptions,
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                current: removedPagination.page,
                total: totalElementsForRemoved,
                onShowSizeChange: (current, pageSize) =>
                  changePageSize(tableIds.removedTable, pageSize, current),
                onChange: (current) => onPageChange(tableIds.removedTable, current),
              }}
              scroll={{ x: "max-content", y: "calc(64vh)" }}
            />
          ) : (
            <div>There are no members that will be removed</div>
          )}
        </div>
      </CollapsePanel>
    );
  }

  function returnExistingMembersTable() {
    return (
      <Panel
        header={
          <>
            <div>
              <ShieldUserFillIcon className={"staying-icon"} />
            </div>
            <div>
              Existing team members who match all the above conditions (
              {totalElementsForStaying ? totalElementsForStaying : 0})
            </div>
          </>
        }
        key="3"
      >
        <div className={"preview-table-container"}>
          {totalElementsForStaying > 0 ? (
            <div>
              <AuthZTable
                id={tableIds.stayingTable}
                rowKey={"key"}
                columns={modifiedColumns}
                dataSource={stayingData}
                loading={isLoadingForStaying}
                rowClassName={rowClassNameFn}
                pagination={{
                  showSizeChanger: true,
                  showQuickJumper: true,
                  pageSize: stayingPagination.size,
                  pageSizeOptions: defaultPageSizeOptions,
                  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                  current: stayingPagination.page,
                  total: totalElementsForStaying,
                  onShowSizeChange: (current, pageSize) =>
                    changePageSize(tableIds.stayingTable, pageSize, current),
                  onChange: (current) => onPageChange(tableIds.stayingTable, current),
                }}
                scroll={{ x: "max-content", y: "calc(64vh)" }}
              />
            </div>
          ) : (
            <div>There are no members matching the existing conditions</div>
          )}
        </div>
      </Panel>
    );
  }

  function renderMembershipCollapse() {
    const activeKeyArray = [];
    if (totalElementsForAdded > 0) {
      activeKeyArray.push('1');
    }
    if (totalElementsForRemoved > 0) {
      activeKeyArray.push('2');
    }
    return (
      <div>
        <div><br /><b>Membership</b></div>
        <CollapseComponent defaultActiveKey={activeKeyArray} panels={[returnNewMembersMatchingConditions(), returnPeopleLosingMembershipTable(), returnExistingMembersTable()]}>
        </CollapseComponent>
      </div>
    )
  }

  function getPanelTitleBasedOnAction() {
    if (action === KeyConditionAction.EDIT) {
      return "Edited";
    } else if (action === KeyConditionAction.ADD) {
      return "Added";
    }
    return "Deleted";
  }

  function renderDeletionWarningMessage() {
    return (
      <div className={"preview-removed-header"}>
        {totalElementsForRemoved > 0 ? (
          <span className={"removed-warning-filled"}>
            {getDeleteMessage()}{" "}
            <WarningFilled/>{" "}
            <span className="removed-warning-filled-sentence">
              ({totalElementsForRemoved}) People losing membership
            </span>
          </span>
        ) : null}
      </div>
    )
  }

  function renderIndividualInclusion() {
    return (
      <Panel
        header={`${getPanelTitleBasedOnAction()} ${
          isIndividualInclusionNamingEnabled ? "Individual Inclusion" : "special member"
        }`}
        key="1"
      >
        <div>
          <SpecialCondition selectSpecialUser={selectSpecialUser} action={action} />
        </div>
      </Panel>
    );
  }

  function renderExistingIndividualInclusionsPanel() {
    return (
      <div>
        <br />
        <b>
          {isIndividualInclusionNamingEnabled ? <>Individual Inclusions</> : <>Special Members</>}
        </b>
        <CollapseComponent panels={[renderExistingIndividualInclusions()]}></CollapseComponent>
      </div>
    );
  }

  function renderKeyConditions() {
    return (
      <div><br /><b>Key Conditions</b>
        <CollapseComponent defaultActiveKey={['1']} panels={[renderExistingKeyConditions(), renderOtherKeyConditions()]}>
        </CollapseComponent>
      </div>
    )
  }

  function renderOtherKeyConditionsPanle() {
    return (
      <div><br /><b>Key Conditions</b>
        <CollapseComponent panels={[renderOtherKeyConditions()]}>
        </CollapseComponent>
      </div>
    )
  }

  function renderIndidualInclusionsPanel() {
    return (
      <div>
        <br />
        <b>
          {isIndividualInclusionNamingEnabled ? <>Individual Inclusions</> : <>Special Members</>}
        </b>
        <CollapseComponent
          defaultActiveKey={["1"]}
          panels={[renderIndividualInclusion(), renderExistingIndividualInclusions()]}
        />
      </div>
    );
  }

  return (
    <>
      {loading||isLoadingForAdded||isLoadingForRemoved === true ? null : (
        <div>
          {renderDeletionWarningMessage()}
          {action === KeyConditionAction.ADD ? (
            <div>
              {renderMembershipCollapse()}
              {isSpecialConditionChecked ? (
                <div>
                  {renderIndidualInclusionsPanel()}
                  {renderOtherKeyConditionsPanle()}
                </div>
              ) : (
              <div>
                {renderKeyConditions()}
                {renderExistingIndividualInclusionsPanel()}
              </div>)}
            </div>) : null }
          {action === KeyConditionAction.EDIT  || action === KeyConditionAction.DELETE? (
            <div>
              {isSpecialConditionChecked ? (
                <div>
                  {renderIndidualInclusionsPanel()}
                  {renderMembershipCollapse()}
                  {renderOtherKeyConditionsPanle()}
                </div>
              ) : (
                <div>
                  {action === KeyConditionAction.EDIT? (
                    <>
                      {renderKeyConditions()}
                      {renderMembershipCollapse()}
                    </>
                  ): (
                    <>
                       {renderMembershipCollapse()}
                       {renderKeyConditions()}
                    </>
                  )}
                  {renderExistingIndividualInclusionsPanel()}
                </div>
              )}
            </div>) : null }
        </div>
      )}
    </>
  );
};

const SpecialCondition = ({ selectSpecialUser, action }) => {
  function getDeleteClassName() {
    if (action === KeyConditionAction.DELETE) {
      return "delete-special-condition";
    } else {
      return "";
    }
  }

  const columns = [
    {
      title: "Business Team member",
      dataIndex: "userName",
      key: "userName",
      sortEnabled: false,
      searchEnabled: false,
      render: (userName, specialConditionRecord) => {
        return (
          <div className="special-condition-member">
            <div className="special-condition-member-first-line">
              <span className="special-condition-member-name">{userName},</span>
              <span className="special-condition-member-employee-id">
                {specialConditionRecord?.userEmployeeId}
              </span>
            </div>
            <div>{specialConditionRecord?.userEmail}</div>
          </div>
        );
      },
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      sortEnabled: false,
      searchEnabled: false,
    },
  ];
  return (
    <div>
      <div className={`special-conditions-table-${getDeleteClassName()}`}>
        <AuthZTable
          name="individual-inclusion-members-list"
          rowKey="userId"
          dataSource={[selectSpecialUser]}
          columns={columns}
          pagination={false}
        />
      </div>
    </div>
  );
};
